module.exports = __webpack_public_path__ + "static/media/Vendas1.f6e7d760.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas1.png
// module id = 1771
// module chunks = 0